<form [formGroup]="agregarFormCondOficinaVenta">
  <div class="row">
    <div class="col-lg-12">
      <app-lfsa-input [control]="this.agregarFormCondOficinaVenta.get('id_promo')" [id]="'id_promo'"
        [isReadOnly]="true" [label]="'ID PROMO'" formControlName="id_promo" type="text"></app-lfsa-input>
    </div>
    <div class="col-lg-12 mb-5">
      <label for="id_oficina_venta">Oficina Venta</label>
      <select class="form-control" formControlName="id_oficina_venta" id="id_oficina_venta">
        <option value="">Seleccione una opción</option>
        <option *ngFor="let data of cmbOficinaVenta" [value]="data.idOficinaVenta">{{ data.idOficinaVenta + ' - ' + data.dscaOficinaVenta }}</option>
      </select>
    </div>
  </div>
  <app-lfsa-botones-formulario (devolverAccion)="accionesCondOficinaVenta( $event )"
    [formularioValido]="(!agregarFormCondOficinaVenta.invalid) ? false : true"
    [textBoton]="'Guardar'" class="row">
  </app-lfsa-botones-formulario>
</form>
